import AuthService from './AuthService';
import RequestBuilder from '../Lib/Requests';

export default class TagService {
  auth = new AuthService();
  api = new RequestBuilder();

  // Create tag request
  buildCreateTagRequest(gatewayID, orgID, data, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/gateway/${gatewayID}/tag`,
      method: 'post',
      params: { orgID },
      data,
      cancelToken,
    };
  }
  async createNewTag(gatewayID, orgID, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildCreateTagRequest(gatewayID, orgID, body, cancelToken)
    );
    return data;
  }
  // Get a specific tag request
  buildFetchTagRequest(gatewayID, tagID, orgID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/gateway/${gatewayID}/tag/${tagID}`,
      method: 'get',
      params: { orgID },
      cancelToken,
    };
  }
  async fetchTag(gatewayID, tagID, orgID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchTagRequest(gatewayID, tagID, orgID, cancelToken)
    );
    return data;
  }
  // Get all tags request
  buildFetchAllTagsRequest(gatewayID, params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/gateway/${gatewayID}/tag`,
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchAllTags(gatewayID, params, cancelToken) {
    const { data } = await this.api.request(
      this.buildFetchAllTagsRequest(gatewayID, params, cancelToken)
    );
    return data;
  }
  //Edit tag request
  buildEditTagRequest(gatewayID, tagID, orgID, data, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/gateway/${gatewayID}/tag/${tagID}`,
      method: 'put',
      params: { orgID },
      data,
      cancelToken,
    };
  }
  async editTag(gatewayID, tagID, orgID, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildEditTagRequest(gatewayID, tagID, orgID, body, cancelToken)
    );
    return data;
  }
  //Delete tag request
  buildDeleteTagRequest(gatewayID, tagID, orgID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/gateway/${gatewayID}/tag/${tagID}`,
      method: 'delete',
      params: { orgID },
      cancelToken,
    };
  }
  async deleteTag(gatewayID, tagID, orgID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildDeleteTagRequest(gatewayID, tagID, orgID, cancelToken)
    );
    return data;
  }
  // search for existing tag names
  buildSearchNameRequest(orgID, nameSearch, cancelToken) {
    return {
      service: 'gateway',
      endpoint: '/v2/tags',
      method: 'get',
      params: { orgID: orgID, nameSearch: nameSearch },
      cancelToken,
    };
  }
  async getTagNames(orgID, nameSearch, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildSearchNameRequest(orgID, nameSearch, cancelToken)
    );
    return data;
  }
  // search for tags by name or value match
  buildSearchTagRequest(params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: '/v2/tags',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async getTags(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildSearchTagRequest(params, cancelToken)
    );
    return data;
  }
}
